export const costCalculator = (cost) => {
  if (!cost || typeof cost !== 'object' || cost.amount == null) return 0;

  switch (cost.period) {
    case 'One Off':
      return cost.amount[0] || 0;
    case 'Yearly':
      return cost.amount[0] / 12;
    case 'Monthly':
      return cost.amount[0];
    case 'Weekly':
      return cost.amount[0] * 4.33;
    case 'Daily':
      return cost.amount[0] * 30.4;
    case 'Manual':
      return cost.amount;
    default:
      return cost.amount[0];
  }
};

export const renderMoney = (num) => {
  return new Intl.NumberFormat('en-GB').format(num);
};

export const calculateProgress = (value, max) => (value / max) * 100;
